import React from 'react';

import AccountsActivityTable from '@tcs/client-portal-common/components/molecules/AccountsActivityTable';

const AccountsActivity = () => {
  return <AccountsActivityTable accountStatus="Active" />;
};

export default AccountsActivity;
